import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { useOneIPlanningMechanicsQuery } from "modules/UsersDashboard/components/PairUsers/hooks/useOneIPlanningMechanicsQuery";
import { useGetUsersDashboardFilters } from "modules/UsersDashboard/components/UsersDashboardFilters/hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { OneiPlanningMonteur } from "models";
import type { PairedUserState } from "modules/UsersDashboard/components/PairUsers";

const constructPayload = (pairedUsers: PairedUserState[], oneIPlanningMechanics: OneiPlanningMonteur[] = []) =>
  pairedUsers.flatMap(({ pair_to, user_id }) => {
    const pairedUser = oneIPlanningMechanics.find(oneIPlanningMechanic => oneIPlanningMechanic.onei_planning_monteur_id === pair_to);
    return pairedUser ? { ...pairedUser, onei_user_id: user_id } : [];
  });

export const useUpdatePairOneIUsersMutation = (pairedUsers: PairedUserState[]) => {
  const {
    filters: { dealer_location_ids }
  } = useGetUsersDashboardFilters();
  const { data: oneIPlanningMechanics } = useOneIPlanningMechanicsQuery(dealer_location_ids);

  return useTypedMutation<void, void>({
    mutationFn: async () =>
      (await ApiInstance.post("/users/pairing/onei/update", { onei_planning_monteurs: constructPayload(pairedUsers, oneIPlanningMechanics) }, ENV.systemBaseURL)).data,
    onSuccess: () => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, {
        ...prevUsers,
        users: prevUsers.users.map(user => {
          const paired = pairedUsers.find(pairedUser => pairedUser.user_id === user.id);
          return paired ? { ...user, onei_planning_monteur_id: paired.pair_to ?? undefined } : user;
        })
      });
    }
  });
};
